import React, { memo } from "react";
import { TextDescription } from "../../utils/styles";
import history from "../../utils/history";

const getRegisterUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const origemParam = params.get("o");
  let goToRegisterURL = "/cadastroPerfil";
  const loginTenant = localStorage.getItem("loginTenant");
  const litPassCheck = window.location.pathname.includes("litpass");
  const vocacaoCheck = window.location.pathname.includes("vocacao");
  if (litPassCheck) {
    goToRegisterURL += `LitPass`;
  } else if (vocacaoCheck) {
    goToRegisterURL += `Vocacao`;
  }
  if (loginTenant) {
    goToRegisterURL += `/${loginTenant.toLowerCase()}`;
  }
  if (origemParam) {
    goToRegisterURL += `?o=${origemParam}`;
  }
  return goToRegisterURL;
};

const NovaConta = () => {
  const handleRedirect = (e) => {
    e.preventDefault();
    const url = getRegisterUrl();
    history.push(url);
  };

  return (
    <div className="criar-conta">
      <TextDescription className="mt-3">
        <p className="font-weight-bold mb-1">Ainda não tem conta?</p>
        <span>
          <span style={{ color: "#58595b" }}>
            Crie uma conta para acessar o{" "}
          </span>
          <a href="#" onClick={handleRedirect}>LIT</a>
        </span>
        <br />
      </TextDescription>
    </div>
  );
};

export default memo(NovaConta);
